<template>
	<!-- 新建/编辑产品表单 -->
	<div class="hg-data-entry">
    <pt-sub-title title="检测项知识库信息"></pt-sub-title>
		<pt-form-item label="所属检测项" :labelWidth="labelWidth" :required="true">
      <el-select v-model="dataEntryForm.detectionItemId" @change="choose(dataEntryForm.detectionItemId)"
        filterable
        remote
        clearable
        reserve-keyword
        placeholder="输入关键词可检索"
        :remote-method="remoteMethod"
        :loading="loading">
        <el-option
          v-for="item in filterDetections"
          :key="item.id"
          :label="item.chineseName"
          :value="item.id">
        </el-option>
      </el-select>
			<!-- <el-input v-model="dataEntryForm.detectionItemId" name="chineseName" v-validate="'required'" data-vv-as="检测项名称" placeholder="请输入检测项名称"></el-input> -->
		</pt-form-item>
    <pt-form-item label="报告展示名称" :labelWidth="labelWidth" :required="true">
			<el-input v-model="dataEntryForm.chineseName" name="chineseName" v-validate="'required'" data-vv-as="报告展示名称" placeholder="请输入报告展示名称"></el-input>
		</pt-form-item>
    <pt-form-item label="常用药品名" :labelWidth="labelWidth">
			<el-input type="textarea" rows="3" class="special" v-model="dataEntryForm.commonDrugsName"  placeholder="请输入常用药品名"></el-input>
		</pt-form-item>
		<pt-form-item label="所属知识库" :labelWidth="labelWidth" :required="true">
      <corpus-selector v-model="dataEntryForm.corpusName" name="corpusName" v-validate="'required'" data-vv-as="所属知识库"></corpus-selector>
			<!-- <el-input v-model="dataEntryForm.corpusName" name="corpusName" v-validate="'required'" data-vv-as="所属知识库" placeholder="请输入所属知识库"></el-input> -->
		</pt-form-item>
		<component :is="formatForm" v-model="dataEntryForm.inlineForm" ref="inlineForm" :labelWidth="labelWidth" :type="currentDetectionType" :corpusName="dataEntryForm.corpusName"></component>
  </div>
</template>
<script>
/**
 * 产品新建/编辑页面
 */
import { validate } from 'utils/validate'
import { formatdetection, formatCategoryToType } from 'enumeration/lab-order.js'
import defaultForm from './default-form'
import corpusSelector from 'cps/gene-product/selector/corpus-selector'
export default {
  name: 'data-entry-form',
  components: {
    defaultForm,
    corpusSelector
  },
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      labelWidth: '110px',
      dataEntryForm: JSON.stringify(this.value) !== '{}' ? this.matchForm(this.value) : {
        chineseName: '',
        englishName: '',
        type: '',
        detectionItemId: '',
        contents: [],
        inlineForm: {},
        corpusName: ''
      },
      getOk: [],
      filterDetections: [],
      loading: false,
      allDetectionsList: [],
      currentDetectionType: ''
    }
  },
  watch: {
    dataEntryForm: {
      handler: function (val, oldval) {
        this.dataEntryForm = val
        this.$emit('input', val)
      },
      deep: true
    },
    value: {
      handler: function (val, oldval) {
        this.dataEntryForm = val
      },
      deep: true
    }
  },
  computed: {
    checkType () {
      if (this.dataEntryForm.type) {
        return true
      }
      return false
    },
    detectionType () {
      return this.formatdetection(this.dataEntryForm.type)
    },
    formatForm () {
      // if (this.dataEntryForm.agentId === 'vcanClinic') {
      //   return 'zhongyuanweikang'
      // } else {
      return 'defaultForm'
      // }
    }
  },
  methods: {
    formatdetection,
    formatCategoryToType,
    // formValidate () {
    //   return validate(this, this.statusForm)
    // },
    formValidate () {
      let formArr = ['ruleForm', 'inlineForm']// 假设这是四个form表单的ref
      var resultArr = []// 用来接受返回结果的数组
      var _self = this
      function checkForm (formName) { // 封装验证表单的函数
        var result
        if (formName === 'inlineForm') {
          result = validate(_self.$refs[formName], _self.dataEntryForm.inlineForm)
        } else {
          result = validate(_self, _self.dataEntryForm)
        }
        resultArr.push(result) // push 得到promise的结果
      }
      formArr.forEach(item => { // 根据表单的ref校验
        checkForm(item)
      })
      return resultArr
    },
    reset () {
      this.dataEntryForm = {
        inlineForm: {}
      }
      this.$refs.inlineForm.reset()
    },
    matchForm (form) {
      form.inlineForm = {}
      if (form.type) {
        form.inlineForm.type = form.type
      }
      if (form.risk) {
        form.inlineForm.risk = form.risk
      }
      if (form.concern) {
        form.inlineForm.concern = form.concern
      }
      if (form.normal) {
        form.inlineForm.normal = form.normal
      }
      if (form.contents) {
        form.inlineForm.contents = form.contents
      }
      this.getTargetDetection(form.detectionItemId)
      return form
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        this.$store.dispatch('searchDetectionItem', query).then(res => {
          this.filterDetections = res.data
          this.loading = false
        }).catch(err => {
          this.loading = false
          console.log(err)
          this.$message.error(err)
        })
      } else {
        this.filterDetections = []
      }
    },
    choose (value) {
      if (!value) {
        this.dataEntryForm.chineseName = ''
      } else {
        this.dataEntryForm.chineseName = this.filterDetections.filter(item => item.id === value)[0].chineseName

        this.currentDetectionType = formatCategoryToType(this.filterDetections.filter(item => item.id === value)[0].category)
        // console.log('this.currentDetectionType', this.currentDetectionType)
        this.dataEntryForm.inlineForm.type = this.currentDetectionType
        // this.dataEntryForm.corpusName = this.dataEntryForm.chineseName
      }
    },
    getTargetDetection (id) {
      this.$store.dispatch('getDetection', id).then(res => {
        this.filterDetections = [res.data]
      })
    }
  },
  created () {
    console.log('detectionItemId', this.dataEntryForm)
  }
}

</script>
<style lang="less">
.hg-data-entry{
  margin-bottom: 20px;
  .el-input,.el-selector{
    max-width: 280px;
    width: 280px;
  }
  .el-textarea{
    max-width: 500px;
    &.special{
      max-width: 280px;
    }
  }
}
</style>
